module.exports = __webpack_public_path__ + "img/rang7.ef972fd1.png";